import axios from 'axios';

import {
  FETCH_DISPUTE_TYPES,
  FETCH_DISPUTE_TYPES_LOADING,
  FETCH_SALES_RESULTS_GROUP_CATALOG,
  FETCH_SESSION_LOTS,
  FETCH_SESSION_LOTS_LOADING,
  FETCH_SESSION_RESULTS_SUCCESS,
  setIsSessionResultsLoading,
  SUBMIT_DISPUTE_ACTION,
  SUBMIT_DISPUTE_ACTION_LOADING,
  SET_FILTERED_SALES_GROUPS,
  SET_IS_SESSION_RESULTS_LOADING,
  CLEAR_SELECTED_CATALOGS
} from './reducer';

import {
  setIsDefaultMessagesLoading,
  setDefaultMessages,
  setIsDefaultMessagesSuccess,
  setIsSubmittingFeedback,
  removeFeedbackForLot,
  addOrUpdateFeedbackForLot
} from './actions';
import { azaStageazaPath } from '../../utilities/UrlPaths';
import { processedSessionResultsData } from './helpers';

const path = azaStageazaPath();

export const setSalesGroupsLoading = isLoading => ({
  type: SET_IS_SESSION_RESULTS_LOADING,
  payload: isLoading
});

export const fetchSalesResultsGroups = houseRef => async dispatch => {
  try {
    const { data } = await axios.get(`${path}/house/${houseRef}/allPastGroups`);

    dispatch({
      type: FETCH_SALES_RESULTS_GROUP_CATALOG,
      payload: data?.data?.groups || []
    });
  } catch (err) {
    dispatch({
      type: FETCH_SALES_RESULTS_GROUP_CATALOG,
      payload: []
    });
  }
};

export const setFilteredSalesGroups = (filteredArray) => async dispatch => {
  dispatch({
    type: SET_FILTERED_SALES_GROUPS,
      payload: filteredArray
  })
};

export const clearSelectedCatalogs = () => async dispatch => {
  dispatch({
    type: CLEAR_SELECTED_CATALOGS,
    payload: []
  })
}

export const fetchSessionResults = (houseRef, lotRef) => async dispatch => {
  try {
    dispatch(setIsSessionResultsLoading(true));
    const authHeader = { Authorization: `${houseRef}*` };

    const { data } = await axios.post(
      `/app/house/${houseRef}/catalogs/sessionResults`,
      [...lotRef],
      { headers: authHeader }
    );

    dispatch({
      type: FETCH_SESSION_RESULTS_SUCCESS,
      payload: processedSessionResultsData(data?.data) || []
    });
    dispatch(setIsSessionResultsLoading(false));
  } catch (error) {
    dispatch(setIsSessionResultsLoading(false));
  }
};

export const fetchDisputeTypes = houseRef => async dispatch => {
  try {
    dispatch({
      type: FETCH_DISPUTE_TYPES_LOADING
    });
    const authHeader = { Authorization: `${houseRef}*` };

    const { data } = await axios.get(`/app/house/${houseRef}/disputeTypes`, {
      headers: authHeader
    });

    dispatch({
      type: FETCH_DISPUTE_TYPES,
      payload: data?.data || {}
    });
  } catch (error) {
    console.error(error);
  }
};
export const fetchSessionLots = (houseRef, lotRefs) => async dispatch => {
  try {
    dispatch({
      type: FETCH_SESSION_LOTS_LOADING
    });
    const authHeader = { Authorization: `${houseRef}*` };

    const { data } = await axios.post(`/app/house/${houseRef}/lots/sessionResults`, lotRefs, {
      headers: authHeader
    });

    dispatch(fetchDisputeTypes(houseRef));
    dispatch({
      type: FETCH_SESSION_LOTS,
      payload: processedSessionResultsData(data?.data) || {}
    });
  } catch (error) {
    console.error(error);
  }
};

export const submitDisputeAction = (houseRef, payload) => async dispatch => {
  try {
    dispatch({
      type: SUBMIT_DISPUTE_ACTION_LOADING
    });
    const authHeader = { Authorization: `${houseRef}*` };

    const { data } = await axios.post(`/app/house/${houseRef}/disputes`, payload, {
      headers: authHeader
    });

    dispatch({
      type: SUBMIT_DISPUTE_ACTION,
      payload: data?.data || {}
    });
  } catch (error) {
    console.error(error);
  }
};

export const fetchDefaultFeedbackMessages = (houseRef, setLoadingFeedbackModalData={}, fromFeedback=false) => async dispatch => {
  try {
    dispatch(setIsDefaultMessagesLoading(true));
    const { data } = await axios.get(`/app/house/${houseRef}/defaultFeedbacks`);
    dispatch(setDefaultMessages(data?.data?.defaultFeedbacks || []));
    dispatch(setIsDefaultMessagesLoading(false));
    if (fromFeedback) {
      setLoadingFeedbackModalData(false);
    }
  } catch (error) {
    dispatch(setDefaultMessages([]));
    dispatch(setIsDefaultMessagesLoading(false));
    if (fromFeedback) {
      setLoadingFeedbackModalData(false);
    }
  }
};

export const saveDefaultFeedbackMessages = (houseRef, defaultFeedbacks) => async dispatch => {
  try {
    dispatch(setIsDefaultMessagesLoading(true));
    dispatch(setIsDefaultMessagesSuccess(false));
    const { data } = await axios.post(`/app/house/${houseRef}/defaultFeedbacks`, {
      defaultFeedbacks
    });

    dispatch(setDefaultMessages(data?.data?.defaultFeedbacks || []));
    dispatch(setIsDefaultMessagesLoading(false));
    dispatch(setIsDefaultMessagesSuccess(true));
  } catch (error) {
    dispatch(setDefaultMessages([]));
    dispatch(setIsDefaultMessagesLoading(false));
    dispatch(setIsDefaultMessagesSuccess(false));
  }
};

export const submitFeedback = (houseRef, payload) => async dispatch => {
  try {
    dispatch(setIsSubmittingFeedback(true));
    const { data } = await axios.post(`/app/house/${houseRef}/feedback`, payload);
    const feedbacks = data.data.feedbacks;
    const lotRefs = payload.lotRefs;
    dispatch(addOrUpdateFeedbackForLot({ feedbacks, lotRefs }));
    dispatch(setIsSubmittingFeedback(false));
  } catch (error) {
    dispatch(setIsSubmittingFeedback(false));
  }
};

export const removeFeedback = (houseRef, lotRef, memberID) => async dispatch => {
  try {
    const { data } = await axios.post(`/app/house/${houseRef}/removeFeedback`, { lotRef });

    if (data?.data?.success) {
      dispatch(removeFeedbackForLot({ lotRef, memberID }));
    }
  } catch (error) {
    console.error(error);
  }
};
